import { configureStore } from '@reduxjs/toolkit';

import { combineReducers } from 'redux';
import UserSliceReducer from './Reducers/UserSlice';
import RolesAndPermissionsReducer from './Reducers/RolesAndPermissionsSlice';
import PermissionsReducer from './Reducers/PermissionsSlice';
import NotificationSnackbarReducer from './Reducers/NotificationSnackbarSlice';
import AdminUsersSliceReducer from './Reducers/AdminUsersSlice';
import HomebannersSliceReducer from './Reducers/HomebannersSlice';
import AlertDialogSliceReducer from './Reducers/AlertDialogSlice';
import NavigationSliceReducer from './Reducers/NavigationSlice';
import CategoriesSliceReducer from './Reducers/CategoriesSlice';
import ProductsSliceReducer from './Reducers/ProductsSlice';
import CustomerSettingsSliceReducer from './Reducers/CustomerSettingSlice';
import CustomerAppSliceReducer from './Reducers/CustomerAppSlice';
import CustomerRefundSliceReducer from './Reducers/CustomerRefundSlice';
import AuditLogReducer from './Reducers/AuditLogSlice';
import NavigationAuditRegexReducer from './Reducers/NavigationAuditRegexSlice';
import SettingsSliceReducer from './Reducers/SettingsSlice';
import OrderErrorsSliceReducer from './Reducers/OrderErrorsSlice';
import OrderRerunsSliceReducer from './Reducers/OrderRerunsSlice';
import DriverRatingsSliceReducer from './Reducers/DriverRatingsSlice';

// Combine all reducers
const rootReducer = combineReducers({
  user: UserSliceReducer,
  rolesAndPermissions: RolesAndPermissionsReducer,
  permissions: PermissionsReducer,
  notificationSnackbar: NotificationSnackbarReducer,
  adminUsers: AdminUsersSliceReducer,
  homebanners: HomebannersSliceReducer,
  alertDialog: AlertDialogSliceReducer,
  navigations: NavigationSliceReducer,
  categories: CategoriesSliceReducer,
  products: ProductsSliceReducer,
  customerSettings: CustomerSettingsSliceReducer,
  customerApp: CustomerAppSliceReducer,
  customerRefund: CustomerRefundSliceReducer,
  auditLog: AuditLogReducer,
  navigationAuditRegex: NavigationAuditRegexReducer,
  settings: SettingsSliceReducer,
  orderErrors: OrderErrorsSliceReducer,
  orderReruns: OrderRerunsSliceReducer,
  driverRatings: DriverRatingsSliceReducer,
});

// Configure store
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // alertDialog state stores onConfirm/onCancel callbacks, which aren't serializable
      serializableCheck: false,
    }),
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
